import { render, staticRenderFns } from "./patentpoolManage.vue?vue&type=template&id=254e7659&scoped=true"
import script from "./patentpoolManage.vue?vue&type=script&lang=js"
export * from "./patentpoolManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e7659",
  null
  
)

export default component.exports